import { render, staticRenderFns } from "./AxHome.vue?vue&type=template&id=1e80c0e6&scoped=true"
import script from "./AxHome.vue?vue&type=script&lang=ts"
export * from "./AxHome.vue?vue&type=script&lang=ts"
import style0 from "./AxHome.vue?vue&type=style&index=0&id=1e80c0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e80c0e6",
  null
  
)

export default component.exports